import React, { Component } from "react";
import { Header, Segment, Input, Icon } from "semantic-ui-react";

class MessagesHeader extends Component {
    state = {
        currentGroupName: this.props.currentGroupName,
        subheader: this.props.subheader
    };

    static getDerivedStateFromProps(nextProps) {
        return {
            currentGroupName: nextProps.currentGroupName,
            subheader: nextProps.subheader
        };
    }

    render() {
        const { currentGroupName, subheader } = this.state;
        const { handleSearchChange, searchInput, searching } = this.props;

        return (
            <Segment
                clearing
                style={{
                    background: "transparent",
                    border: "1px solid transparent",
                    boxShadow: "none",
                    padding: "0em 0em",
                    marginTop: "0.7em"
                }}
            >
                <Header
                    fluid="true"
                    as="h2"
                    floated="left"
                    style={{ marginBottom: 0, color: "black" }}
                >
                    {currentGroupName}
                    <Header.Subheader style={{ color: "black" }}>
                        {subheader}
                    </Header.Subheader>
                </Header>
                <Header floated="right" style={{ marginRight: "0" }}>
                    <Input
                        type="text" onKeyPress={e => {
                            if (e.key === 'Enter') e.preventDefault();
                        }}
                        id="search__group__input"
                        loading={searching}
                        onChange={handleSearchChange}
                        size="mini"
                        icon={
                            <Icon
                                id="messages__search__icon"
                                name="search"
                                inverted
                                circular
                                link
                            />
                        }
                        name="searchTerm"
                        placeholder="Search chats for this project"
                        value={searchInput}
                        style={{ marginRight: "0" }}
                    />
                </Header>
            </Segment>
        );
    }
}

export default MessagesHeader;
